import * as React from "react";
import {
  OriginThemeProvider,
  TrackingProvider,
} from "@origin-digital/ods-core";
import { trackingProviderCaptureClick } from "@origin-digital/reporting-client";
import "url-search-params-polyfill";
import { BrowserRouter } from "react-router-dom";
import { AppContextProvider } from "./AppContext";
import { Router } from "./router";
import { injectGlobal } from "styled-components";
// eslint-disable-next-line no-undef
if (__DEV__) {
  // eslint-disable-next-line babel/no-unused-expressions
  injectGlobal`
    html {
      background-color: #f1f1f1;
      height:100%;
    }
    body {
      margin: 0;
      font-family: gordita, sans-serif;
      height: 100%;
    }
  `;
}

export default (config: IAppConfig) => {
  return (
    <OriginThemeProvider>
      <TrackingProvider onTrackingCapture={trackingProviderCaptureClick}>
        <AppContextProvider config={config}>
          <BrowserRouter>
            <Router />
          </BrowserRouter>
        </AppContextProvider>
      </TrackingProvider>
    </OriginThemeProvider>
  );
};
